import React from 'react';
const AgentAvailable = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M19.6,10.6c-0.3-0.7-0.7-1.4-1.3-1.9c-1.2-1.2-2.9-1.8-4.6-1.6c-0.1-0.2-0.3-0.3-0.4-0.4C12.4,5.6,11,5,9.5,5   S6.6,5.6,5.6,6.6C4.6,7.6,4,9,4,10.5c0,0.1,0,0.2,0,0.3c-0.2,0.2-0.5,0.3-0.7,0.6c-0.9,0.8-1.3,2-1.3,3.2C2,17,4,19,6.5,19h11   c1.2,0,2.3-0.5,3.2-1.3c0.9-0.8,1.3-2,1.3-3.2C22,12.8,21.1,11.3,19.6,10.6z M19.3,16.3c-0.5,0.5-1.1,0.7-1.8,0.7h-11   C5.1,17,4,15.9,4,14.5c0-0.7,0.3-1.3,0.7-1.8c0.2-0.2,0.5-0.4,0.7-0.5c0.4-0.2,0.7-0.6,0.6-1.1C6,10.9,6,10.7,6,10.5   C6,9.6,6.4,8.7,7,8c0.7-0.7,1.5-1,2.5-1s1.8,0.4,2.5,1c0.2,0.2,0.4,0.4,0.5,0.7c0.2,0.4,0.7,0.5,1.1,0.4C13.9,9,14.2,9,14.5,9   c0.9,0,1.8,0.4,2.5,1c0.4,0.4,0.7,0.9,0.9,1.5c0.1,0.3,0.3,0.5,0.6,0.7c0.9,0.4,1.5,1.3,1.5,2.3C20,15.2,19.7,15.8,19.3,16.3z"
            fill="currentColor" />

    </svg>
);


export default AgentAvailable;

